// Force video autoplay on collection page product cards (MOBILE ONLY)
document.addEventListener('DOMContentLoaded', function() {
  
  // Only run on mobile devices
  if (window.innerWidth > 990) {
    return; // Exit on desktop - it's already working
  }
  
  // Function to play video
  function playVideo(video) {
    if (video && video.tagName === 'VIDEO' && !video.playing) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.play().catch(function(error) {
        // If autoplay fails, that's ok - user will see play button
        console.log('Video autoplay prevented:', error);
      });
    }
  }
  
  // Play all visible videos immediately
  const allVideos = document.querySelectorAll('.card--product video, .product-card video');
  allVideos.forEach(function(video) {
    playVideo(video);
  });
  
  // Use Intersection Observer for lazy-loaded/scrolled videos
  const videoObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const video = entry.target;
        playVideo(video);
      }
    });
  }, {
    root: null,
    rootMargin: '100px',
    threshold: 0.1
  });
  
  // Observe all product card videos
  allVideos.forEach(function(video) {
    videoObserver.observe(video);
  });
  
  // Handle dynamically loaded products (infinite scroll, load more, etc)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const videos = node.querySelectorAll('video');
          videos.forEach(function(video) {
            playVideo(video);
            videoObserver.observe(video);
          });
        }
      });
    });
  });
  
  // Observe the product grid for new products
  const productGrid = document.querySelector('#product-grid, .collection-product-list');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
});